const BZCCGameWatch = [
  [
    "2025",
    "Battlezone Combat Commander Game Watch",
    "A real-time, open-source platform for tracking and watching Battlezone: Combat Commander matches live.",
    "https://battlezonescrapfield.github.io/BZCC-Website/",
  ],
];

const BZCCStatistics = [
  [
    "2025",
    "Battlezone Combat Commander Strategy Statistics",
    "A JSON API displaying Battlezone Combat Commander strategy games.",
    "https://herndone.github.io/battlezone-combat-commander-strategy-statistics/",
  ],
];

const PortfolioWebsite = [
  [
    "2024",
    "Ethan Herndons Portfolio Website",
    "Portfolio website built with React, JavaScript, HTML, and CSS, and deployed on GitHub Pages.",
    "https://github.com/HerndonE/Portfolio-Website",
  ],
];

const MineCraftBot = [
  [
    "2023",
    "Discord Bot for Vanilla Minecraft (Java Edition)",
    "A Discord bot communicates with people and players between Discord and Minecraft.",
    "https://github.com/HerndonE/Vanilla-Minecraft-Discord-Bot",
  ],
];

const DP2ServerPage = [
  [
    "2023",
    "Server Page Update For Digital Paintball 2",
    "Updated HTML for Digital Paintball 2 server page. ",
    "https://digitalpaint.org/docs/server_guide_win32.html",
  ],
];

const MacroPad = [
  [
    "2023",
    "Nexopixel 1x4 Custom Macro Pad",
    "Using the Adafruit NeoKey 1x4 QT I2C Breakout, I customized the keycodes for media capture, and game play. ",
    "https://github.com/HerndonE/Nexopixel-1x4-Custom-Macro-Pad",
  ],
];

const BZCCColorEditor = [
  [
    "2022",
    "Color Editor Program for Battlezone Combat Commander",
    "Program to edit team colors for Battlezone Combat Commander.",
    "https://github.com/HerndonE/BZCC-Color-Editor",
  ],
];

const RosterBoard = [
  [
    "2022",
    "Roster Board For Slack",
    "The roster board is a Python program designed to notify users when it's their turn for a specific activity on Slack.",
    "https://github.com/HerndonE/Roster-Board-for-Slack",
  ],
];

const CurrencyConverter = [
  [
    "2021",
    "Currency Converter",
    "A simple android app that converts currency between the US and Brazil.",
    "https://github.com/HerndonE/Android-US-BRL-Converter",
  ],
];

const SSMTPMessenger = [
  [
    "2020",
    "SSMTP Messenger",
    "A simple way for users to use a send-only sendmail emulator.",
    "https://github.com/HerndonE/SSMTP-Messenger",
  ],
];
const BZCCLostMissions = [
  [
    "2020",
    "Battlezone Combat Commander: Lost Missions Campaign",
    "Introducing 5 new missions for Battlezone Combat Commander; follow the ISDF on their pursuit to destroy the Scion. This fan made campaign branches parallel with the ISDF campaign bringing a new adventure for the game.",
    "https://github.com/HerndonE/Battlezone-Missions",
  ],
];
const GortBot = [
  [
    "2020",
    "Gort Bot for Discord",
    "A little Discord bot is a multi-purpose bot focusing on enhancing the discord experience for all users.",
    "https://github.com/HerndonE/Gort-Bot",
  ],
];

const GonzalesApp = [
  [
    "2020",
    "City of Gonzales App",
    "The City of Gonzales partnered with the Computer Science Department at California State University Monterey Bay to make a mobile application for its community to help eliminate the Digital Divide. This application aims to achieve community feedback while having access to important information and announcements from the Gonzales city government through their android mobile devices.",
    "https://github.com/HerndonE/Gonzales-App?tab=readme-ov-file",
  ],
];

const BZCCColorSelector = [
  [
    "2019",
    "Battlezone Color Selector",
    "Players in Battlezone Combat Commander now have the opportunity to select colors of their choosing before a multiplayer game.",
    "https://github.com/HerndonE/Battlezone-Color-Selector",
  ],
];

const PingTool = [
  [
    "2017",
    "Ping Interface Tool",
    "Using Python, created a graphical user interface for I.T. staff at Rohnert Park Public Safety to easily ping static and dynamic devices on the network that speeds up the troubleshooting process.",
    "",
  ],
];

const HoverTankGame = [
  [
    "2015",
    "Hover Tank Space Game",
    "Utilizing the Unity gaming engine, developed a futuristic 3D hover tank space game that immerses players to take control of a futuristic hover tank and engage in intense aerial combat, destroying enemy invaders with an arsenal of weapon types.",
    "",
  ],
];

const ProjectsContainer = [
  BZCCGameWatch,
  BZCCStatistics,
  PortfolioWebsite,
  MineCraftBot,
  DP2ServerPage,
  MacroPad,
  BZCCColorEditor,
  RosterBoard,
  CurrencyConverter,
  SSMTPMessenger,
  BZCCLostMissions,
  GortBot,
  GonzalesApp,
  BZCCColorSelector,
  PingTool,
  HoverTankGame,
];

export { ProjectsContainer };

/*
[
"",
"",
"",
"",
],
*/
